// TODO 到后面用model把地址列表页面 /address/add /address/list 也用这个替换掉
import { BaseModel, MutationResult, QueryResult, restMutation, restQuery } from 'vue-apollo-model';
import { Toast } from '@ks/sharp-ui';

export interface Address {
    addressId?: number;
    consignee: string;
    mobile: string;
    provinceCode?: number;
    province?: string;
    cityCode?: number;
    city?: string;
    districtCode?: number;
    district?: string;
    townCode?: number;
    town?: string;
    address: string;
    isDefault: 0 | 1; // 是默认地址为1，不是默认地址为0
    createTime?: number;
    updateTime?: number;
}

export default class AddressModel extends BaseModel {
    @restMutation({
        url: '/rest/lightks/wd/address/list',
        method: 'post',
    })
    addressListQuery!: MutationResult<null, { result: number; addressList: Address[] }>;

    getAddressList() {
        this.addressListQuery.mutate(null);
    }

    get addressList() {
        return this.addressListQuery.data.addressList || [];
    }
    get defaultAddress() {
        return this.addressList.find(address => address.isDefault) || this.addressList[0];
    }

    @restMutation<AddressModel>({
        url: '/rest/lightks/wd/address/delete',
        method: 'post',
        variables(params) {
            return params;
        },
    })
    deleteAddressMutation!: MutationResult<{ addressId: string }, Res>;

    async deleteAddress(addressId: string) {
        if (this.addressList.length <= 1) {
            Toast.error('收货地址不能为空，无法删除');
        } else {
            await this.deleteAddressMutation.mutate({ addressId });
            this.getAddressList();
        }
    }

    @restMutation<AddressModel>({
        url: '/rest/lightks/wd/address/add',
        method: 'post',
        variables(params) {
            return params;
        },
    })
    addAddressMutation!: MutationResult<{ courseAddressDTO: Address }, Res>;

    addAddress(courseAddressDTO: Address) {
        return this.addAddressMutation.mutate({ courseAddressDTO });
    }

    @restMutation<AddressModel>({
        url: '/rest/lightks/wd/address/update',
        method: 'post',
        variables(params) {
            return params;
        },
    })
    updateAddressMutation!: MutationResult<{ courseAddressDTO: Address }, Res>;

    updateAddress(courseAddressDTO: Address) {
        return this.updateAddressMutation.mutate({ courseAddressDTO });
    }

    @restMutation({
        url: '/rest/lightks/wd/course/gift/saveAndUseAddress',
        method: 'post',
        variables(params) {
            return params;
        },
    })
    saveAndUseAddressMutation!: MutationResult<
        { courseAddressDTO: Address; giftID: string; updateAllGift: boolean },
        Res
    >;

    saveAndUseAddress(address: Address) {
        return this.saveAndUseAddressMutation.mutate({
            courseAddressDTO: address,
            giftID: '',
            updateAllGift: true,
        });
    }
}
